import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const VIEW_AS_USER_SCHEMA = z.object({
  requested_user: z.string(),
});

export type ViewAsUserParams = z.infer<typeof VIEW_AS_USER_SCHEMA>;

const VIEW_AS_USER_RESPONSE_SCHEMA = z.object({ message: z.string() });

export const viewAsUserPromise = async (params: ViewAsUserParams) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const validateParams = VIEW_AS_USER_SCHEMA.safeParse(params);

    if (!validateParams.success) {
      console.error(validateParams.error);
    }

    const response = await ky
      .post(`${ENV.API_URL}/external-user-management/view-as-user/`, {
        body: JSON.stringify(params),
        headers,
      })
      .json();

    const res = VIEW_AS_USER_RESPONSE_SCHEMA.safeParse(response);

    if (!res.success) {
      return null;
    }

    return res.data?.message;
  } catch (error) {
    console.error('Error fetching view as user:', error);
    return null;
  }
};
